import React from "react";
import AddToCartBTN from "../../../../User/Home/Components/Homepage/UI-item,viewAll,BtmSheet/AddToCartBTN";

import logo from "../../../../img/LOGO.webp";
const ProductCard = ({ products, subCat }) => {
  return subCat.map((cat, i) => (
    <div
      className="horiz-scroll plp-list"
      key={`${cat}+${i}+${Math.random()}`}
      id={cat}
    >
      {products.map((product) => {
        if (product.subCat === cat) {
          return (
            <div
              key={product.pID + Math.random()}
              className="card"
              id={product?.mainCat}
            >
              <div className="card-top-image">
                {product.mrp !== product.sp &&
                  Math.trunc(((product.mrp - product.sp) / product.mrp) * 100) >
                    2 && (
                    <span className="plp-procard">
                      {Math.trunc(
                        ((product.mrp - product.sp) / product.mrp) * 100
                      )}
                      % Off
                    </span>
                  )}

                {product?.imageURL ? (
                  <img
                    src={product?.imageURL}
                    loading="lazy"
                    alt="product"
                    width="auto"
                    height="100%"
                  />
                ) : (
                  <img
                    src={logo}
                    loading="lazy"
                    alt="product"
                    width="auto"
                    height="100%"
                  />
                )}
              </div>
              <div className="card-body">
                <h3>{product?.newProductName}</h3>
                <span className="item-weight">{product?.newProductSize}</span>
                <h5>
                  <strong>{`₹${product.sp}`}</strong>
                  {product.mrp !== product.sp && <del>{`₹${product.mrp}`}</del>}
                </h5>
                {product.mrp !== product.sp && (
                  <span className="badge badge-success">{`Save ₹${Math.trunc(
                    product.mrp - product.sp
                  )}`}</span>
                )}
                <AddToCartBTN item={product} />
              </div>
            </div>
          );
        }
        return null;
      })}
    </div>
  ));
};

export default ProductCard;
